export const IMPORT_STATUS_INTERVAL = 1000
export const IMPORT_STATUS_INTERVAL_LONG = 5000
export const IMPORT_STATUS_LONG_INTERVAL_START_ATTEMPT = 11;

// react-dropzone >= 14 chce mapy MIME -> rozszerzenia zamiast listy rozszerzeń.
// Pliki tachografu nie mają własnego typu MIME, stąd octet-stream.
export const IMPORT_DEFAULT_ACCEPT = {
  'application/octet-stream': ['.ddd', '.dtc', '.dtg', '.tgd', '.esm', '.v1b', '.c1b', '.rcv'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
  'text/csv': ['.csv'],
  'text/xml': ['.xml'],
}
export const IMPORT_DRIVER_ACCEPTED_FILE_EXTENSIONS = ['.ddd', '.dtc', '.dtg', '.tgd', '.esm', '.v1b', '.c1b', '.rcv']
